import React from 'react';
import { Alert, Button, Space, Tag } from 'antd';
import { SortAscendingOutlined, SortDescendingOutlined, CloseOutlined } from '@ant-design/icons';
import { getSortColumnLabel } from '../../constants/sortableColumns';

interface GlobalSortBarProps {
  sortColumn: string | null;
  sortOrder: 'ascend' | 'descend' | null;
  onClear: () => void;
  tierCount: number;
}

export const GlobalSortBar: React.FC<GlobalSortBarProps> = ({
  sortColumn,
  sortOrder,
  onClear,
  tierCount,
}) => {
  if (!sortColumn || !sortOrder) {
    return null;
  }

  const label = getSortColumnLabel(sortColumn);
  const isAscending = sortOrder === 'ascend';

  return (
    <Alert
      type="info"
      showIcon
      icon={isAscending ? <SortAscendingOutlined /> : <SortDescendingOutlined />}
      message={
        <Space size="middle" wrap>
          <span>
            Sorting all {tierCount} tables by:{' '}
            <Tag color="blue" style={{ marginLeft: 4 }}>
              {label}
            </Tag>
          </span>
          <span style={{ color: '#666' }}>
            {isAscending ? '↑ Low to High' : '↓ High to Low'}
          </span>
          <Button
            size="small"
            icon={<CloseOutlined />}
            onClick={onClear}
          >
            Clear Sort
          </Button>
        </Space>
      }
      style={{ marginBottom: 16 }}
    />
  );
};
